import { render, staticRenderFns } from "./VaccinationBasedOnType.vue?vue&type=template&id=6f3b05c0&scoped=true&"
import script from "./VaccinationBasedOnType.vue?vue&type=script&lang=js&"
export * from "./VaccinationBasedOnType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b05c0",
  null
  
)

export default component.exports